import React from 'react';
import { Box, Typography } from '@mui/material';

const OpenCareBrand = ({ variant = 'h4', gutterBottom = false, onDark = false, sx }) => (
  <Typography
    variant={variant}
    component="h1"
    gutterBottom={gutterBottom}
    sx={{
      fontWeight: 800,
      letterSpacing: '-0.5px',
      color: onDark ? '#ffffff' : 'text.primary',
      ...sx
    }}
  >
    Open
    <Box component="span" sx={{ color: 'secondary.main' }}>
      Care
    </Box>
  </Typography>
);

export default OpenCareBrand;
